angular.module('tct.authService', ['tct.configService'])
  .factory('authService', authService);

authService.$inject = ['configService', '$http'];

function authService(config, $http) {
  const basePath = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/api/auth`;
  const factory = {
    login,
    logout,
    getMe,
    requestResetPassword,
    validateResetPasswordToken,
    resetPassword,
    changePassword,
  };

  return factory;

  function login(email, password) {
    const url = `${basePath}/login`;
    const payload = new FormData();
    payload.append('email', email);
    payload.append('password', password);

    const httpconfig = {
      withCredentials: true,
      headers: { 'Content-Type': undefined },
    };
    return $http.post(url, payload, httpconfig);
  }

  function getMe() {
    const url = `${basePath}/me`;
    const httpconfig = {
      withCredentials: true,
      headers: { 'Content-Type': undefined },
    };
    return $http.get(url, httpconfig);
  }

  function logout() {
    const url = `${basePath}/logout`;
    return $http.post(url);
  }

  function requestResetPassword(email) {
    const payload = new FormData();
    payload.append('email', email);

    const httpConfig = {
      withCredentials: true,
      headers: { 'Content-Type': undefined },
    };

    return $http.post(`${basePath}/request-reset-password`, payload, httpConfig);
  }

  function validateResetPasswordToken(token, email) {
    const payload = new FormData();
    payload.append('token', token);
    payload.append('email', email);

    const httpConfig = {
      withCredentials: true,
      headers: { 'Content-Type': undefined },
    };

    return $http.post(`${basePath}/validate-reset-token`, payload, httpConfig);
  }

  function resetPassword(token, email, password, passwordConfirmation) {
    const payload = new FormData();
    payload.append('token', token);
    payload.append('email', email);
    payload.append('password', password);
    payload.append('password_confirmation', passwordConfirmation);

    const httpConfig = {
      withCredentials: true,
      headers: { 'Content-Type': undefined },
    };

    return $http.post(`${basePath}/reset-password`, payload, httpConfig);
  }

  function changePassword(currentPassword, password, passwordConfirmation) {
    const payload = new FormData();
    payload.append('current_password', currentPassword);
    payload.append('password', password);
    payload.append('password_confirmation', passwordConfirmation);

    const httpConfig = {
      withCredentials: true,
      headers: { 'Content-Type': undefined },
    };

    return $http.post(`${basePath}/change-password`, payload, httpConfig);
  }
}
